module.exports = __webpack_public_path__ + "img/mms_logo_black.05d26668.svg";